export default {"src":"/_next/static/media/footerLogo1.da4e0196.svg","height":44,"width":88,"blurWidth":0,"blurHeight":0};